import { Authority, RegisterCompanyUserMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const registerCompanyUserHandler =
  graphql.mutation<RegisterCompanyUserMutation>(
    "registerCompanyUser",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          registerCompanyUser: {
            user: {
              sub: "sub1",
              username: "username1",
              authority: Authority.Admin,
              lastName: "名字(更新後)",
              lastNameKana: "ミョウジコウシンゴ",
              middleName: "ミドルネーム(更新後)",
              middleNameKana: "ミドルネームカナコウシンゴ",
              firstName: "名前(更新後)",
              firstNameKana: "ナマエカナコウシンゴ",
            },
          },
        },
      });
    }
  );
